import type { RouteRecordName } from '#vue-router'

export function checkIfIndexPage(routeName?: RouteRecordName | null) {
  return /^(index|regions-rid)__/.test(routeName?.toString() ?? '')
}

export function checkIfBranchesPage(routeName?: RouteRecordName | null) {
  return !!routeName?.toString().startsWith('branches-bid')
}

export function checkIfRegionPage(routeName?: RouteRecordName | null) {
  return !!routeName?.toString().startsWith('regions-rid')
}

export function checkIfCategoriesPage(routeName?: RouteRecordName | null) {
  return !!routeName?.toString().startsWith('regions-rid-categories-cid')
}

export function checkIfThemesPage(routeName?: RouteRecordName | null) {
  return !!routeName?.toString().startsWith('regions-rid-themes-tid')
}

export function checkIfTagsPage(routeName?: RouteRecordName | null) {
  return !!routeName?.toString().startsWith('regions-rid-tags-tagId')
}

export function checkIfProductListPage(routeName?: RouteRecordName | null) {
  return /^regions-rid-(categories|search|themes|tags)/.test(routeName?.toString() ?? '')
}

export function checkIfBookingPage(routeName?: RouteRecordName | null) {
  return !!routeName?.toString().startsWith('booking')
}

export function checkIfOrderListPage(routeName?: RouteRecordName | null) {
  return !!routeName?.toString().startsWith('member-orders')
}

export function checkIfOrderDetailPage(routeName?: RouteRecordName | null) {
  return !!routeName?.toString().startsWith('orders-oid')
}

export function checkIfAccountDeletionPage(routeName?: RouteRecordName | null) {
  return !!routeName?.toString().startsWith('account-deletion')
}

export function checkIfNoShowConfirmPage(routeName?: RouteRecordName | null) {
  return !!routeName?.toString().startsWith('orders-oid-no-show-confirm')
}

export function getBranchPageLink(branchId?: number | string) {
  if (typeof branchId === 'undefined') {
    throw new Error('branchId is required')
  }

  return `/branches/${branchId}`
}
